// src/theming.js
import { createTheming } from "@callstack/react-theme-provider";
import { themes } from "./themes";

// Default theme is "sage" — the primary Peaceful Oasis palette
const { ThemeProvider, withTheme, useTheme } = createTheming(themes.sage);

export { ThemeProvider, withTheme, useTheme };
